import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-PossessoryInterest',
    templateUrl: './PossessoryInterest.component.html',
    styleUrls: ['./PossessoryInterest.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PossessoryInterestComponent implements OnInit {
  open=true;
  constructor() { }

  ngOnInit() {
  }

}
